
import React from "react";

import ImageUploading from 'react-images-uploading';
import { Button,ButtonToolbar } from 'rsuite';







const Bulkstep1 = () => {
  const [images, setImages] = React.useState([]);
  const maxNumber = 69;

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  
  

    
 
    return (
      <div className="App">
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // write your building UI
          <div className="upload__image-wrapper">
            <ButtonToolbar style={{'marginTop':'-50px'}}>
            <Button
              style={ { 'backgroundColor':'#3498ff','margin':'2px','color':'white','marginLeft':'10px', 'marginTop':'10px'} }
              onClick={onImageUpload}
              {...dragProps}
            >
              Click or Drop here
              </Button>
            &nbsp;
            <Button  style={{'backgroundColor':'red','margin':'2px','color':'white','marginLeft':'10px', 'marginTop':'10px'}} onClick={onImageRemoveAll}>Remove all images
        </Button>
        </ButtonToolbar>
        <div style={{'display':'flex','marginTop':'38px'}}>
            {/* <button style={ { 'backgroundColor':'red','margin':'2px','color':'white'} } 
            onClick={onImageRemoveAll}>Remove all images</button> */}
            {imageList.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image['data_url']} alt="" width="100" />
                <div className="image-item__btn-wrapper">
                  <Button style={ { 'backgroundColor':'#3498ff','margin':'2px','color':'white'} }onClick={() => onImageUpdate(index)}>Update</Button>
                  <Button style={{'backgroundColor':'red','margin':'2px','color':'white'}}  onClick={() => onImageRemove(index)} >Remove</Button>
                </div>
              </div>
            ))}
            </div>
          </div>
        )}
      </ImageUploading>
    </div>
    );
};

export default Bulkstep1;